<template>
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_tujuan='lkp_tujuan'
    v-if="id > 0 && load == 2"
  />
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_tujuan='lkp_tujuan'
    v-else-if="id == 0 && load == 1"
  /> 
  <Form 
    :d_form='c_form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_tujuan='lkp_tujuan'
    v-else-if="id == 0 && load == 2"
  /> 
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.permohonan.ai',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Permohonan Pembiakan Perkhidmatan', route: '/art/permohonan/form/0' },
      ],
      title : 'Permohonan Pembiakan Perkhidmatan',
      form : {
        id : 0,
        premis_id : '',
        masa : '',
        tarikh_pengesanan_biang : '',
        masa_pengesanan_biang : '',
        lkp_negeri_id : '',
        lkp_status_id : '',
        lkp_art_id : '1',
        lkp_ternakan_id : '',
        lkp_tujuan_id : 0,
        kode : '',
        p : 0,
        ternakan_list : [],
        lkp_berahi_id: '',
         jenis_semen:'',
      },
      c_form:{
         id : 0,
         premis_id : '',
         masa : '',
         tarikh_pengesanan_biang : '',
         masa_pengesanan_biang : '',
         lkp_negeri_id : '',
         lkp_status_id : '',
         lkp_art_id : '1',
         lkp_ternakan_id : '',
         lkp_tujuan_id : 0,
         kode : '',
         p : 0,
         ternakan_list : [],
         lkp_berahi_id: '',
         juruteknik_id: '',
         jenis_semen:'',
      },
      premis_id : [],
      ternakan_list:[],
      premis : [],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      lkp_art : [],
      lkp_tujuan : [],
      load : 0
      
      
    }
  },
  methods: {
    

      
 
     getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }
      
    },
    getSalin(id){
      var now = new Date();
        this.$zcomm.get(this.api_service + 'art/show/'+id, {}).then(res => {
          this.form = res;
          this.c_form.id = 0;
          this.c_form.premis_id = res.premis_id;
          this.c_form.lkp_ternakan_id = res.lkp_ternakan_id;
          this.c_form.lkp_art_id = res.lkp_art_id;
          this.c_form.masa = res.masa;
          this.c_form.pasung = res.pasung;
          this.c_form.lkp_negeri_id = res.lkp_negeri_id;
          this.c_form.tarikh_pengesanan_biang = now.getFullYear()+'-'+("00" + (now.getMonth() + 1)).slice(-2)+'-'+("00" + (now.getDate() + 1)).slice(-2);
          this.c_form.masa_pengesanan_biang = ("00" + now.getHours()).slice(-2) + ":" +("00" + now.getMinutes()).slice(-2) + ":" + ("00" + now.getSeconds()).slice(-2);
          this.c_form.lkp_ternakan_id = res.lkp_ternakan_id;
          this.c_form.lkp_tujuan_id = res.lkp_tujuan_id;
          this.c_form.kode = res.kode;
          this.c_form.lkp_berahi_id = res.lkp_berahi_id;
          this.c_form.juruteknik_id = res.juruteknik_id;
          this.c_form.lkp_negeri = res.lkp_negeri;
          this.load = this.load + 1
        })

       
      },

    getNegeri(){
         this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.lkp_negeri = res
            this.load = this.load + 1
         })
    },

   getTujuanPd(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res
      })
    },

  
  },

  watch: {

  },
  mounted() {
    this.getData()
    this.getNegeri()
    // this.getTujuanPd()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.salin && this.params.salin > 0){
      
      this.getSalin(this.params.salin)
    }
    
  }
    
}
</script>
